<template>
  <div class="guide-processing">
    <div class="title">拥有办理信用购领豪礼的资格！</div>
    <div class="desc" v-if="recommendMeal.package">
      <div class="tit">推荐套餐</div>
      <div class="desc-intro">
        <div class="intro">
          <h2>1. 每月保底消费58元</h2>
          <p>可享价值330元礼包</p>
        </div>
        <div class="intro">
          <h2>2. 直接升档至59元移动王卡PLUS套餐</h2>
          <p>可得移动黑卡PLUS权益会员</p>
          <p>每月均可95折购超市现金券（每百元即可立省5元）</p>
          <p>8折大牌白酒（最高立省902元）</p>
          <p>2折品牌耳机音箱（最高立省1580元）</p>
          <p>3折热门视频会员（最低只要3.5元）</p>
        </div>
        <h2>3. 保底消费至68元，礼包价值增至390元</h2>
        <h2>4. 保底消费至78元，礼包价值增至440元</h2>
        <h2>5. 保底消费至88元，礼包价值增至500元</h2>
        <h2>6. 保底消费至98元，礼包价值增至560元</h2>
      </div>
    </div>
    <div class="desc" v-else-if="recommendMeal.member">
      <div class="tit">推荐套餐</div>
      <div class="desc-intro">
        <div class="intro">
          <h2>1. 每月保底消费58元</h2>
          <p>可享价值330元礼包</p>
        </div>
        <div class="intro">
          <h2>2. 加办移动黑卡PLUS会员月包（每月仅需10元）</h2>
          <p>提升保底消费可多得礼包至560元</p>
          <p>每月均可95折购超市现金券（每百元即可立省5元）</p>
          <p>8折大牌白酒（最高立省902元）</p>
          <p>2折品牌耳机音箱（最高立省1580元）</p>
          <p>3折热门视频会员（最低只要3.5元）</p>
        </div>
        <h2>3. 保底消费至68元，礼包价值增至390元</h2>
        <h2>4. 保底消费至78元，礼包价值增至440元</h2>
        <h2>5. 保底消费至88元，礼包价值增至500元</h2>
        <h2>6. 保底消费至98元，礼包价值增至560元</h2>
      </div>
    </div>
    <div class="footer" v-show="recommendMeal.package || recommendMeal.member">
      <div class="enquiry-network">
        <button @click="enquiryNetwork">查询网点</button>
      </div>
      <div class="check-status">
        <button
          :class="{ checked: checked }"
          @click="swichCheck"
          class="unchecked"
        ></button>
        <span v-if="recommendMeal.member"
          >办理10元包月内蒙古移动黑卡PLUS会员，尽享会员省钱及返福利金权益</span
        >
        <span v-if="recommendMeal.package"
          >升档至移动王卡PLUS 59元套餐，尽享黑卡PLUS会员省钱及返福利金权益</span
        >
      </div>
    </div>
    <dialogs
      :cancel-text="dialog.cancelText"
      :show-msg="false"
      @cancel-handler="cancelHandler"
      @confrim-handler="confrimHandler"
      class="dialogs"
      v-model="dialog.show"
    >
      <div class="desc">
        查看信用购领豪礼活动，
        <em v-if="recommendMeal.package">办理网点</em>
        <br />
        <em v-if="recommendMeal.package"
          >并升档至 {{ recommendMeal.package.name }}
          {{ recommendMeal.package.simple_title }}</em
        >
        <em v-if="recommendMeal.member"
          >办理内蒙古{{ recommendMeal.member.name }}
          {{ recommendMeal.member.price.price }}元/月</em
        >
        <br />尽享黑卡PLUS会员省钱及返福利金权益
      </div>
    </dialogs>
  </div>
</template>

<script>
import Dialogs from '../../components/Dialog'
export default {
  name: 'hornoBuyGuide',
  components: {
    Dialogs
  },
  data () {
    return {
      checked: true,
      recommendMeal: {},
      dialog: {
        show: false,
        cancelText: '取消'
      }

    }
  },
  computed: {
    offerid () {
      return this.recommendMeal.package && this.recommendMeal.package.offer_id
    },
    level () {
      return this.recommendMeal.member && this.recommendMeal.member.level
    },
    type () {
      return this.recommendMeal.member && this.recommendMeal.member.price.type
    }

  },
  created () {
    this.getUserRecommend()
  },
  methods: {
    swichCheck () {
      this.checked = !this.checked
    },
    cancelHandler () {
      this.$router.push({ name: 'hornorBuyGuiteEnquiries' })
    },
    async confrimHandler () {
      let status = false
      if (this.recommendMeal.package) {
        status = await this.upgradePackageHandler()
      } else if (this.recommendMeal.member) {
        status = await this.openingHandler()
      }
      if (status) {
        this.$router.push({ name: 'hornorBuyGuiteEnquiries' })
      } else {
        return false
      }
    },

    /**
     * 办理会员
     */
    async openingHandler () {
      this.$toast.loading('正在办理请稍后...')
      const res = await this.$axios.post('api/member/order', {
        level: this.level,
        type: this.type
      })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg } = res.data
        if (code === 0) {
          this.dialog.show = false
          this.$toast('已成功提交办理申请')
          return true
          // location.href = data.redirect
        } else {
          this.$toast(msg)
          return false
        }
      }
    },

    /**
     * 办理升档
     */
    async upgradePackageHandler (id) {
      this.$toast.loading('正在办理,请稍后...')
      const res = await this.$axios.post('api/member/pkg-order', {
        offer_id: this.offerid
      })
      if (res.status === 200) {
        const { code, msg } = res.data
        if (code === 0) {
          this.$toast('办理申请已提交')
          return true
        } else {
          this.$toast(msg)
          return false
        }
      }
    },
    /**
     * 查询
     */
    async enquiryNetwork () {
      if (this.checked) {
        this.dialog.show = true
      } else {
        this.$router.push({ name: 'hornorBuyGuiteEnquiries' })
      }
    },

    /**
     * 获取用户推荐
     */
    async getUserRecommend () {
      const res = await this.$axios.get('api/business/mr')
      if (res.status === 200) {
        const { code, data } = res.data
        if (code === 0) {
          this.recommendMeal = data.top_member
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@keyframes mymove {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(0.9); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}
.guide-processing {
  width: 100%;
  min-height: 13.34rem;
  background: url('../../assets/img/hornor-buy/suc.png') top left no-repeat
    #fff4e3;
  background-size: 7.5rem 13.34rem;
  .title {
    padding: 2.4rem 0 0.37rem;
    font-size: 0.3rem;
    text-align: center;
    color: #ff5753;
  }
  .desc {
    font-size: @fz22;
    margin: 0 0.3rem 1.3rem;
    border-radius: 15px;
    overflow: hidden;
    background-color: #fff;
    .tit {
      width: 100%;
      height: 0.92rem;
      color: #fff;
      .flex-center;
      letter-spacing: 2px;
      font-size: 0.34rem;
      font-weight: bold;
      background: linear-gradient(
        167deg,
        rgb(255, 140, 137) 0%,
        rgb(255, 118, 115) 100%
      );
    }
    .desc-intro {
      padding: 0 0.3rem 0.4rem;
    }
    h2 {
      font-size: 0.34rem;
      padding-top: 0.3rem;
      font-weight: 660;
      color: #ff5757;
    }
    p {
      font-size: @fz24;
      padding-top: 0.1rem;
      color: #979797;
    }
  }
  .footer {
    padding-bottom: 1rem;
    background-color: #fff;
    // left: 0;
    // right: 0;
    // position: absolute;
    // top: 9.6rem;
  }
  .enquiry-network {
    width: 4.84rem;
    height: 1.14rem;
    margin: 0 auto;
    button {
      margin-top: -0.57rem;
      width: 100%;
      height: 100%;
      border-radius: 0.6rem;
      color: #fff;
      letter-spacing: 2px;
      background-image: linear-gradient(
        180deg,
        #ffa99b 0%,
        #ff7462 54%,
        #ff4a37 100%
      );
      box-shadow: 0 2px 13px 0 rgba(255, 149, 149, 0.66);
      font-size: 0.36rem;
      font-weight: 660;
      animation: mymove 3s infinite;
    }
  }

  .check-status {
    // text-align: center;
    padding: 0 1.2rem;
    font-size: @fz22;
    .unchecked,
    .checked {
      width: 0.3rem;
      height: 0.3rem;
      background: url('../../assets/img/hornor-buy/unchecked.png') center
        no-repeat;
      background-size: 100%;
    }
    .checked {
      background: url('../../assets/img/hornor-buy/checked.png') center
        no-repeat;
      background-size: 100%;
    }
    span {
      padding-left: 0.15rem;
    }
  }
  .dialog {
    .desc {
      padding: 0.3rem 0;
      text-align: center;
      font-size: @fz26;
      color: #000;
      line-height: 2;
      padding-bottom: 0.5rem;
    }
  }
}
</style>
